export default "__VITE_ASSET__LagTm$lt__"